var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionDevice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-device-7468505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1171275156"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.3149 12.1875H2.71718C2.52508 12.1875 2.36867 12.0311 2.36867 11.839V5.83438C2.36867 5.64229 2.52508 5.48588 2.71718 5.48588H12.9259C13.118 5.48588 13.2744 5.64229 13.2744 5.83438V6.2165C13.2812 6.69877 13.9995 6.69535 14.0064 6.2165V5.83438C14.0064 5.23892 13.5213 4.75391 12.9259 4.75391H2.71719C2.12173 4.75391 1.63672 5.23892 1.63672 5.83438V11.839C1.63672 12.4345 2.12173 12.9195 2.71719 12.9195H6.46214L6.23782 13.6131H5.55042C5.07157 13.6193 5.06815 14.3375 5.55042 14.3451C6.72215 14.3458 8.92217 14.3451 10.0939 14.3451C10.5741 14.3362 10.5755 13.6227 10.0939 13.6131H9.40652L9.1822 12.9195H10.3155C10.795 12.9113 10.7978 12.1965 10.3155 12.1875L10.3149 12.1875ZM8.63689 13.6124H7.00692L7.23124 12.9189H8.41189L8.63621 13.6124H8.63689Z",
    fill: "#464646",
    stroke: "#464646",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.45508 11.4222C7.46331 11.9031 8.17883 11.9031 8.18707 11.4222C8.17884 10.9413 7.46331 10.9413 7.45508 11.4222Z",
    fill: "#464646",
    stroke: "#464646",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.1746 7.2793H12.4765C11.8715 7.2793 11.3789 7.77186 11.3789 8.37693V13.2469C11.3789 13.852 11.8715 14.3445 12.4765 14.3445H15.1746C15.7797 14.3445 16.2722 13.852 16.2722 13.2469V8.37693C16.2722 7.77186 15.7797 7.2793 15.1746 7.2793ZM15.5403 13.2476C15.5403 13.4493 15.3763 13.6133 15.1746 13.6133H12.4765C12.2749 13.6133 12.1109 13.4493 12.1109 13.2476V8.37763C12.1109 8.17595 12.2749 8.01199 12.4765 8.01199H15.1746C15.3763 8.01199 15.5403 8.17595 15.5403 8.37763V13.2476Z",
    fill: "#464646",
    stroke: "#464646",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.0622 11.8145H13.5833C13.1024 11.8227 13.1024 12.5382 13.5833 12.5464H14.0622C14.5431 12.5382 14.5431 11.8227 14.0622 11.8145Z",
    fill: "#464646",
    stroke: "#464646",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.8256 9.07812C12.3781 9.11586 12.3788 11.2356 13.8256 11.2734C15.2731 11.2357 15.2724 9.11588 13.8256 9.07812ZM13.8256 10.5414C13.3447 10.5325 13.3447 9.81833 13.8256 9.80941C14.3065 9.81833 14.3065 10.5325 13.8256 10.5414Z",
    fill: "#464646",
    stroke: "#464646",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionDevice);
export default __webpack_public_path__ + "static/media/subscriptionDevice.16d3c83ba82d28c421958e8cef60cbd6.svg";
export { ForwardRef as ReactComponent };